import React, { useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import Scrollbars from "react-custom-scrollbars-2";
import { ResizeSensor } from "@blueprintjs/core";
import { mergeRefs } from "utils/data";
import * as styles from "./styles.module.scss";
export var ThumbType;
(function (ThumbType) {
    ThumbType["HORIZONTAL"] = "HORIZONTAL";
    ThumbType["VERTICAL"] = "VERTICAL";
})(ThumbType || (ThumbType = {}));
export const SCROLL_BAR_VIEW_ID = "scrollBarView";
const ScrollBar = ({ scrollBarRef, onActiveThumbChange, viewProps, children, classes, ...restProps }) => {
    const [activeThumb, setActiveThumb] = useState();
    const [isVerticalTrackVisible, setIsVerticalTrackVisible] = useState(false);
    const [isHorizontalTrackVisible, setIsHorizontalTrackVisible] = useState(false);
    const scrollRef = useRef(null); // the Scrollbars component
    const rootDivRef = useRef(null);
    const changeActiveThumb = useCallback((activeThumb) => {
        setActiveThumb(activeThumb);
        onActiveThumbChange && onActiveThumbChange(activeThumb);
    }, [onActiveThumbChange]);
    useEffect(() => {
        if (activeThumb) {
            const listener = () => changeActiveThumb();
            document.addEventListener("mouseup", listener);
            return () => document.removeEventListener("mouseup", listener);
        }
    }, [activeThumb, changeActiveThumb]);
    return (React.createElement(Scrollbars, { ref: mergeRefs(scrollBarRef, scrollRef), renderView: (props) => (React.createElement("div", { id: SCROLL_BAR_VIEW_ID, className: classNames(styles.view, classes?.view), ...props, ...viewProps })), renderTrackVertical: (props) => (React.createElement("div", { className: classNames(styles.track, styles["track-vertical"], classes?.track, classes?.trackVertical), ...props })), renderThumbVertical: (props) => (React.createElement("span", { onMouseDownCapture: () => changeActiveThumb(ThumbType.VERTICAL), className: classNames(styles.thumb, styles["thumb-vertical"], classes?.thumb, classes?.thumbVertical, {
                [styles.active]: activeThumb === ThumbType.VERTICAL,
            }), ...props })), renderTrackHorizontal: (props) => (React.createElement("div", { className: classNames(styles.track, styles["track-horizontal"], classes?.track, classes?.trackHorizontal), ...props })), renderThumbHorizontal: (props) => (React.createElement("span", { onMouseDownCapture: () => changeActiveThumb(ThumbType.HORIZONTAL), className: classNames(styles.thumb, styles["thumb-horizontal"], classes?.thumb, classes?.thumbHorizontal, {
                [styles.active]: activeThumb === ThumbType.HORIZONTAL,
            }), ...props })), hideTracksWhenNotNeeded: true, ...restProps, className: classNames(restProps.className, {
            "scrollBar-isHorizontalTrackVisible": isHorizontalTrackVisible,
            "scrollBar-isVerticalTrackVisible": isVerticalTrackVisible,
        }), onUpdate: (values) => {
            setIsHorizontalTrackVisible(values.clientWidth < values.scrollWidth);
            setIsVerticalTrackVisible(values.clientHeight < values.scrollHeight);
            restProps.onUpdate && restProps.onUpdate(values);
        }, onScrollFrame: (values) => restProps?.onScrollFrame && restProps.onScrollFrame(values, activeThumb) },
        React.createElement(ResizeSensor, { observeParents: true, onResize: () => scrollRef?.current && scrollRef?.current.forceUpdate() },
            React.createElement("div", { ref: rootDivRef, style: { width: "100%" } }, children))));
};
export default ScrollBar;
